import { ApiCallStatus } from "@myRedux/networkState";
import { CircularProgress } from "@componentLibraryWrapper/circularProgress";
import { Button, ButtonProps } from "@componentLibraryWrapper/button";
import { appendClassName } from "@componentLibraryWrapper/common";
import './buttonSubmit.scss'

export interface ButtonSubmitProps extends ButtonProps {
	submitStatus: ApiCallStatus
}

const ButtonSubmit = ({
  children,
  className,
  submitStatus,
  type='submit',
  onClick,
  ...rest
}: ButtonSubmitProps) => {
  let clicked = false;

  function onClickHandler(event: React.MouseEvent<HTMLButtonElement>) {
    if (clicked) {
      event.preventDefault();
      event.stopPropagation();
    }
    clicked = true;
    if (onClick) {
      onClick(event);
    }
  }

  return (
    <>
      {submitStatus === ApiCallStatus.Loading ? (
        <Button
          {...rest}
          className={appendClassName('sm-buttonsubmit sm-buttonsubmit-submitting', className)}
          disabled={true}
          type={type}
        >
          {children}
          <CircularProgress
            size={16}
            color="inherit"/>
        </Button>
      ) : (
        <Button
          {...rest}
          className={appendClassName('sm-buttonsubmit', className)}
          onClick={onClickHandler}
          type={type}
        >
          {children}
        </Button>
      )}
    </>
  );
}

export default ButtonSubmit;